import { render, staticRenderFns } from "./Ceami.vue?vue&type=template&id=aa6b794c&scoped=true&"
import script from "./Ceami.vue?vue&type=script&lang=js&"
export * from "./Ceami.vue?vue&type=script&lang=js&"
import style0 from "./Ceami.vue?vue&type=style&index=0&id=aa6b794c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6b794c",
  null
  
)

export default component.exports